import { get, IHttpRequestConfig } from "@/browser";
import { compose } from "@/core/url";

import { FEATURE_FLAG } from "./types";

const API = {
  features: "/api/features",
};

export const fetchFeatureFlags = async (options?: IHttpRequestConfig) => {
  return await get<FEATURE_FLAG[]>(compose(API.features, {}), options).then(response => response.data);
};
